export const captchaURL     = 'https://www.google.com/recaptcha/api/siteverify';
export const captchaSecret  = '6LfZe74ZAAAAAE0lccaSXhDQ2QrDb3iy6L8ISUz5';
export const PasswordHash   = 'RwJ8hH3alth$CX!!';
export const SaltKey        = 'S@LT&KEY!7$9!!!!';

export class API {

    createRequestOptions = ( method, body ) => {
        const requestOptions = {
            method: method,
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: body
        };

        return requestOptions;
    }

    createRequestData = ( action, requestParams ) => {
        var requestData = {
            'Auth': {
                'Action': action
            },
            'Requestparms': requestParams
        }

        return JSON.stringify( requestData );
    }

    createRequest = ( data ) => {

        var dataString = data.toString();
        
        var request = {
            'Action': '',
            'Context': {
                "AppRefId":null,
        		"AppToken":null,
        		"UserContextId":null,
        		"ProximityCalc":false,
                "AddlContext":
                {
                  "HC_APP_NAME": "HC_DYNAMIC_FORMS"
                }
            },
            'Data': dataString
        }

        return JSON.stringify( request );
    }

    createRequest_QA = ( data ) => {

        var dataString = data.toString();
        
        var request = {
            'Action': '',
            'Context': {
                "AppRefId":null,
        		"AppToken":null,
        		"UserContextId":null,
        		"ProximityCalc":false,
                "AddlContext":
                {
                  "HC_APP_NAME": "GIZMO_REACT"
                }
            },
            'Data': dataString
        }

        return JSON.stringify( request );
    }

    encryptData = ( data ) => {
        const crypto = require( 'crypto-js' );

        var key = crypto.enc.Utf8.parse( PasswordHash );
        var iv  = crypto.enc.Utf8.parse( SaltKey );

        var encrypted = crypto.AES.encrypt( data, key, { iv: iv } );

        return encrypted;
    }

    decryptData = ( data ) => {
        const crypto = require( 'crypto-js' );

        var key = crypto.enc.Utf8.parse( PasswordHash );
        var iv  = crypto.enc.Utf8.parse( SaltKey );

        var decrypted = crypto.AES.decrypt( data, key, { iv: iv } ).toString( crypto.enc.Utf8 );

        return decrypted;
    }
}